import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { generateSlug } from "../../utils/slug";
import "./UnansweredQuestions.css";

const UnansweredQuestions = () => {
    const [listings, setListings] = useState([]);
    const [answerTexts, setAnswerTexts] = useState({});
    const navigate = useNavigate();

    useEffect(() => {
        fetch(`${process.env.REACT_APP_API_URL}/questions/unanswered/listings`, {
            credentials: "include"
        })
            .then(res => res.ok ? res.json() : Promise.reject())
            .then(data => setListings(data.listings))
            .catch(err => console.error("Failed to load unanswered questions:", err));
    }, []);

    const handleAnswer = (questionId, listingId) => {
        const text = answerTexts[questionId];
        if (!text) return alert("Vnesite odgovor.");

        fetch(`${process.env.REACT_APP_API_URL}/questions/${questionId}/answer`, {
            method: "PUT",
            credentials: "include",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ answerText: text })
        })
            .then(res => res.ok ? res.json() : Promise.reject("Answer failed"))
            .then(() => {
                // Remove answered question
                setListings(prev =>
                    prev.map(listing => ({
                        ...listing,
                        questions: listing.questions.filter(q => q.id !== questionId)
                    })).filter(listing => listing.questions.length > 0)
                );
                setAnswerTexts(prev => ({ ...prev, [questionId]: "" }));
            })
            .catch(() => alert("Napaka pri pošiljanju odgovora."));
    };

    return (
        <div className="unans_questions">
            <h2>Neodgovorjena vprašanja</h2>
            <hr className="hr_unans_questions" />

            {listings.length === 0 ? (
                <p>Ni neodgovorjenih vprašanj.</p>
            ) : (
                listings.map(listing => (
                    <div key={listing.id} className="unanswered_listing">
                        <h3>{listing.title}</h3>
                        <ul className="unanswered_list">
                            {listing.questions.map(q => (
                                <li key={q.id} className="unanswered_item">
                                    <p><strong>Vprašanje:</strong> {q.question_text}</p>
                                    <div className="unanswered_actions">
                                        <textarea
                                            placeholder="Vaš odgovor…"
                                            value={answerTexts[q.id] || ""}
                                            onChange={e =>
                                                setAnswerTexts(prev => ({ ...prev, [q.id]: e.target.value }))
                                            }
                                            className="qa_input"
                                        />
                                        <button onClick={() => handleAnswer(q.id, listing.id)} className="qa_button">
                                            Odgovori
                                        </button>
                                        <button
                                            className="go_to_item_btn"
                                            onClick={() => {
                                                const slug = generateSlug(listing.title);
                                                navigate(`/oglas/${slug}/${listing.id}`);
                                            }}
                                        >
                                            Pojdi na oglas
                                        </button>
                                    </div>
                                </li>
                            ))}
                        </ul>
                    </div>
                ))
            )}
        </div>
    );
};

export default UnansweredQuestions;